<template>
  <div class="base">
    <div class="top-head">
      <inside-header title="取消详情" color="white" />
      <div class="program">
        <van-steps :active="current">
          <van-step>提交申请</van-step>
          <van-step>教员审核</van-step>
          <van-step>平台复核</van-step>
          <van-step>取消并退款</van-step>
        </van-steps>
      </div>
    </div>
    <div class="cancel-area">
      <div class="cancel-details">
        <div class="order-info">
          <div class="title">
            {{ service_pack.title }}-{{ order_info.teaching_subject }}
          </div>
          <a-row :gutter="8" class="content-area">
            <a-col :span="5" align="right">
              <div class="item-label">
                订单号
              </div>
              <div class="item-label">
                授课周期
              </div>
              <div class="item-label">
                备注
              </div>
            </a-col>
            <a-col :span="13">
              <div class="item-value">
                {{ order_info.ordernum }}
              </div>
              <div class="item-value">
                {{ order_info.cycle }}周
              </div>
              <div class="item-value">
                {{ order_info.desc }}
              </div>
            </a-col>
            <a-col :span="6">
              <div class="price">
                <span class="prefix">￥</span>
                <span class="money">{{ order_info.subtotal }}</span>
              </div>
            </a-col>
          </a-row>
        </div>
        <van-divider />
        <div class="apply-details">
          <a-row :gutter="8">
            <a-col class="item-label" :span="5" align="right">
              申请时间
            </a-col>
            <a-col class="item-value" :span="19">
              {{ cancel_info.create_time | timeFormat }}
            </a-col>
          </a-row>
          <a-row :gutter="8">
            <a-col class="item-label" :span="5" align="right">
              申请原因
            </a-col>
            <a-col class="item-value" :span="19">
              {{ cancel_info.reason }}
            </a-col>
          </a-row>
          <a-row :gutter="8">
            <a-col class="item-label" :span="5" align="right">
              描述
            </a-col>
            <a-col class="item-value" :span="19">
              {{ cancel_info.reason_description }}
            </a-col>
          </a-row>
          <a-row :gutter="8">
            <a-col class="item-label" :span="5" align="right">
              退款金额
            </a-col>
            <a-col class="item-value" :span="19">
              ￥{{ cancel_info.refund_amount }}
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
    <div class="reply-result">
      <div>
        <div v-show="current === 0" />
        <div v-show="current === 1">
          <span v-if="cancel_info.result_msg">教员意见: {{ cancel_info.result_msg }}</span>
          <span v-else>教员审核中，请等待通知~</span>
        </div>
        <div v-show="current === 2">
          <span v-if="cancel_info.result_msg">教员意见: {{ cancel_info.result_msg }}</span><br>
          <span v-if="cancel_info.platform_result_msg">平台意见: {{ cancel_info.platform_result_msg }}</span>
          <span v-else>平台正在处理中，请等待通知~</span>
        </div>
        <div v-show="current === 3">
          <a-result status="success" title="取消并退款成功">
            <template #icon>
              <img style="" src="@/assets/success.png" alt="">
            </template>
          </a-result>
        </div>
      </div>
    </div>
    <div class="bottom-area">
      <div class="right">
        <a-button type="primary">
          联系教员
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
import { InsideHeader } from '@/components'

export default {
  name: 'UserOrderCancel',
  components: {
    InsideHeader
  },
  filters: {
    payStatusFilter(payStatus) {
      if (payStatus === 'Paid') {
        return '已支付'
      } else if (payStatus === 'Unpaid') {
        return '未支付'
      } else if (payStatus === 'Refund') {
        return '已退款'
      }
    },
    cancelStatusFilter(status) {
      if (status === 'progress') {
        return '进行中'
      } else if (status === 'complete') {
        return '已完成'
      }
    }
  },
  props: {
    ordernum: {}
  },
  data() {
    return {
      loading: true,
      state: {},
      current: 0,
      // 指定当前步骤的状态，可选 wait process finish error
      stepStatus: 'process',
      order_info: {},
      cancel_info: {},
      service_pack: {},
      pay_status_str: '',
      // 家教服务状态
      serviceStatus: '',
      // 申请单状态
      cancelStatus: '',
      // 发起人
      sponsorType: '',
      activeStep: 1
    }
  },
  watch: {
    order_info() { },
    cancel_info(val) {
      // 状态为progress, complete
      // 如果发起人为用户,并且平台介入为N,
      if (val.status === 'complete') {
        this.current = 3
        this.stepStatus = 'finish'
      } else if (val.status === 'progress') {
        // 平台介入Y
        if (val.intervene === 'Y') {
          this.current = 2
        } else if (val.sponsor_type === 'user' && val.confirm === 'N') {
          // 用户发起,并且未被确认
          this.current = 1
        }
      }

      this.serviceStatus = val.service_status
      this.cancelStatus = val.status
      this.sponsorType = val.sponsor_type
    }
  },
  created() {
    this.loadData(this.ordernum)
  },
  methods: {
    loadData(ordernum) {
      this.loading = true
      this.$http({
        url: '/index/user/orderCancelInfo',
        method: 'get',
        params: {
          ordernum: ordernum
        }
      }).then(res => {
        this.loading = false
        if (res.status === 'success') {
          const data = res.data
          this.order_info = data.order_info
          this.cancel_info = data.cancel_info
          this.service_pack = data.service_pack
          console.log(data)
        } else {
          this.$notification.error({
            message: '系统繁忙，请刷新重试',
            description: ''
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus">
.base {
    min-width: 280px;
    max-width: 420px;
    margin: auto;
    background-color: #fff;
}

.top-head {
  width: 100%;
  // background: url('~@/assets/order/back@2x.png') no-repeat;
  background-color: #fa6f20
  // 背景图片自适应div
  background-size: contain

  .program {
    height: 160px
    padding: 15px;

    .van-steps {
      background-color: transparent;
      .van-steps__items {

        .van-step {
          color: #fcb194;
        }

        .van-step__circle-container {
          padding: 0px;
        }

        .van-step--finish {
          color: #fff;
        }

        .van-step--process {
          color: #fff;
          .van-step__title--active {
            color: #fff;
          }
          .van-step__circle-container {
            padding: 0px;
          }
        }
      }
    }
  }
}

.cancel-area {
  position: relative;
  padding: 0px 15px;
  top: -60px;

  .cancel-details {
    padding: 30px 15px 15px 15px;
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);

    .order-info {
      .title {
        font-family: PingFang-SC-Bold;
        font-size: 16px;
        line-height: 16px;
        font-weight: bold;
        color: #333333;
      }

      .content-area {
        margin-top: 15px;
      }
    }

    .price {
      .prefix {
        font-family: PingFang-SC-Medium;
        font-size: 12px;
        line-height: 19px;
        color: #333333;
      }

      .money {
        font-family: PingFang-SC-Medium;
        font-size: 18px;
        color: #333333;
      }
    }

    .item-label {
      font-family: PingFang-SC-Medium;
      font-size: 12px;
      line-height: 19px;
      color: #333333;
    }

    .item-value {
      font-family: PingFang-SC-Medium;
      font-size: 12px;
      color: #666666;
    }
  }

}

.reply-result {
  text-align: center;
  font-family: PingFang-SC-Medium;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 28px;
  letter-spacing: 0px;
  color: #333333;
}

.bottom-area {
  height: 56px;
  overflow: hidden;
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 10px 15px;
  box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);
  background-color: #fff;

  .right {
    float: right

    .cancel-btn {
      width: 87px;
      height: 31px;
      border-radius: 15px;
      border: solid 1px #ececec;

      font-family: PingFang-SC-Medium;
      font-size: 14px;
      line-height: 14px;
      color: #999999;

      margin-right: 10px;
    }

    .pay-btn {
      width: 75px;
      height: 31px;
      background-color: #ff5c00;
      border-radius: 15px;
    }
  }
}
</style>
